import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import provinceService from "../services/province-service";

export const provinceSearchSchema = z.object({
	search: z.string().optional(),
	region_code: z.string().nullable().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
	region: z.string().optional(),
});

export const provincesQueryOptions = (
	search?: z.infer<typeof provinceSearchSchema>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["province", search],
		queryFn: () =>
			provinceService.list(transformSearch(search, ["search", "region_code"])),
		...options,
	});
};

export const provinceQueryOptions = (provinceId: string) => {
	return queryOptions({
		queryKey: ["province", provinceId],
		queryFn: () => provinceService.findById(provinceId),
	});
};

export const useProvinceCreateMutation = (provinceId?: string) => {
	return useMutation({
		mutationKey: ["province", provinceId],
		mutationFn: provinceService.create,
		meta: {
			successMessage: "Province created successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["province"] }),
	});
};

export const useProvinceMutation = (provinceId?: string) => {
	return useMutation({
		mutationKey: ["province", provinceId],
		mutationFn: provinceService.upsert,
		meta: {
			successMessage: "Province updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["province"] }),
	});
};
